import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isFor = ['Padres que viven en México y buscan un estilo de vida orgánico y libre de tóxicos.', 'Madres primerizas que quieren sentirse empoderadas y seguras en sus decisiones de salud.', 'Familias que prefieren alternativas naturales antes de recurrir a la farmacia convencional.', 'Personas que quieren ahorrar tiempo y dinero en visitas innecesarias a urgencias.'];
const isNotFor = ['Personas que buscan sustituir una cirugía o tratamiento médico crítico por hierbas.', 'Padres que no están dispuestos a dedicar 5 minutos a preparar una mezcla natural.', 'Quienes confían ciegamente en la automedicación farmacológica para cada síntoma.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function WhoIsFor() {
  return <section className="py-16 md:py-24 bg-cream-dark/30" data-id="element-144">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-146">
          {/* Para quién es */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-sage/20" data-id="element-147">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-sage-dark font-playfair border-b border-sage/20 pb-4" data-id="element-148">
              Para quién es
            </h3>
            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-6" data-id="element-149">
              {isFor.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-150">
                  <div className="flex-shrink-0 mt-1" data-id="element-151">
                    <div className="w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-152">
                      <Check className="w-4 h-4 text-sage-dark" data-id="element-153" />
                    </div>
                  </div>
                  <p className="ml-4 text-brown-body leading-relaxed" data-id="element-154">{item}</p>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          {/* Para quién NO es */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-terracotta/20" data-id="element-155">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-terracotta font-playfair border-b border-terracotta/20 pb-4" data-id="element-156">
              Para quién NO es
            </h3>
            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-6" data-id="element-157">
              {isNotFor.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-158">
                  <div className="flex-shrink-0 mt-1" data-id="element-159">
                    <div className="w-6 h-6 rounded-full bg-terracotta/10 flex items-center justify-center" data-id="element-160">
                      <X className="w-4 h-4 text-terracotta" data-id="element-161" />
                    </div>
                  </div>
                  <p className="ml-4 text-brown-body leading-relaxed" data-id="element-162">{item}</p>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}